import { useTheme } from "@mui/material";
import * as tokens from "@shape-ds/tokens";
import { Backdrop, Spinner } from "./styles";
import { LoadingProps } from "./types";
import { Theme } from "../Theme";

const Loading = ({
  cover = false,
  size = tokens.SPACING_XL,
  className,
  style,
  dataTestId,
  center,
}: LoadingProps) => {
  const theme = useTheme<Theme>();
  return cover ? (
    <Backdrop>
      <div className={`spin ${className || ""}`} style={style} data-testid={dataTestId}>
        <Spinner size={size} theme={theme} />
      </div>
    </Backdrop>
  ) : (
    <Spinner size={size} theme={theme} className={className} center={center} data-testid={dataTestId} />
  );
};

export default Loading;
